import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cisco-admin-create-challenge',
  templateUrl: './cisco-admin-create-challenge.component.html',
  styleUrls: ['./cisco-admin-create-challenge.component.scss']
})
export class CiscoAdminCreateChallengeComponent {
  @Input() allChallengeTypes: any[] = [];
  @Input() challengeType: string = '';
  @Input() editChallengeData: any = null;
  @Input() challengeData: any;
  @Input() isCiscoAdmin: boolean = false;

  @Output() challengeSelected = new EventEmitter<string>();
  @Output() submitStatus = new EventEmitter<any>();
}
